<template>
  <div>
    <Title :loading="loading">{{ $t("chatSidebar.last") }}</Title>
    <div class="chatWrapp">
      <Message
        v-for="message in conversations"
        :key="message.threadId"
        :message="message"
        @open="openMsg"
      ></Message>
      <div v-intersect="getConversations" class="text-center pt-1">
        <v-progress-circular
          v-if="loading"
          :width="3"
          :size="25"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>
<script>
import * as types from '@/store/modules/chat/chat-mutation-types'
import * as list from '@/types/chat-list'
import Message from '../Shared/Message.vue'
import Title from '../Shared/Title.vue'
import { markAsRead } from '@/signalr/chat.js'
export default {
  name: 'LastMessages',
  data () {
    return {
      loading: false
    }
  },
  components: { Message, Title },
  computed: {
    conversations () {
      return this.$store.getters['chat/lastMessages']
    },
    load () {
      return this.$store.getters['chat/load']
    }
  },
  async created () {
    this.$store.commit(`chat/${types.CLEAR_LAST}`, list.LAST)
    await this.getConversations()
  },
  methods: {
    async getConversations () {
      this.loading = true

      await this.$store.dispatch('chat/getLastMessages')

      this.loading = false
    },
    openMsg (message) {
      const found = this.conversations.find((msg) => msg.conversationId === message.conversationId && msg.threadId === message.threadId)
      if (!found) return
      if (!found.readByCurrentUser) {
        found.readByCurrentUser = true
        markAsRead(found.threadId, found.messageId)
        this.$store.commit(`chat/${types.READ_MSG}`)
      }
      this.$store.dispatch('chat/openConversation', { conversationId: found.conversationId, threadId: found.threadId })
    }
  }
}
</script>
<style scoped>
.msg:last-child {
  border-bottom: solid 0.1px rgba(52, 58, 61, 0.1);
}
</style>
